import { module } from 'modujs';
import gsap from 'gsap'
import barba from '@barba/core';

export default class extends module {
    constructor(m) {
        super(m);

        this.$link = this.$('link')[0]
        this.$image = this.$('image')[0]
    }

    init() {
        const href = this.$link.href;

        if (!barba.cache.has(href)) {
            barba.cache.set(
                href,
                barba.request(
                    href,
                    barba.timeout,
                    barba['onRequestError'].bind(barba, 'barba') // tslint:disable-line:no-string-literal
                ).catch(error => {
                    console.error(error);
                }),
                'prefetch'
            );
        } else {
          barba.cache.update(href, { action: 'prefetch' });
        }

        this.timeline = gsap.timeline({
            onComplete: () => {
                console.log('onComplete');
                // console.trace('onComplete', this.timeline.progress(), document.documentElement.scrollTop);
                this.call('manualGo', this.$link, 'Load')
            }
        })

        this.timeline.from(this.$image, {
            y: '100%',
            // ease: 'linear.none',
            duration: 0.75
        }, 0.25)

        // this.timeline.progress(0.01)
        // this.timeline.progress(0)

        this.timeline.add(() => {}, 1)
        this.timeline.pause()
    }

    onScrollProgress(progress) {

        this.timeline?.progress(progress)
    }
}
